








































import { defineComponent, ref, PropType, watch, onBeforeUnmount } from "@nuxtjs/composition-api";
import CheckStockInStore from "./CheckStockInStore/CheckStockInStore.vue";
import { Product } from "~/modules/catalog/product/types";

export default defineComponent({
  name: "CheckStoreStockButton",
  components: {
    CheckStockInStore,
  },
  props: {
    product: {
      type: [Object, null] as PropType<Product>,
      default: null,
    },
    configurableOptions: Array,
    availableOptions: {
      type: Object as PropType<{ color: any[]; size: any[] }>,
      required: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    dataCheckOptionInstock: Array,
    parentSku: String,
    showColorAlert: Boolean,
    showSizeAlert: Boolean,
    productSelectedOption: {
      type: Object as PropType<{ size: any; color: any }>,
    }
  },
  setup() {
    const isModalCheckStock = ref(false);
    
    const toggleModal = (value: boolean) => {
      isModalCheckStock.value = value;
      if (value) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    };
    
    // Clean up when component is unmounted
    onBeforeUnmount(() => {
      if (isModalCheckStock.value) {
        document.body.style.overflow = '';
      }
    });
    
    // Watch for changes in case the modal state changes through other means
    watch(isModalCheckStock, (newValue) => {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });

    return {
      isModalCheckStock,
      toggleModal
    };
  },
});
